/**
 * English copy for realtime navigation (phase6-contract.md §3.7 / §2 "i18n
 * ownership"): the strings `services/realtime-navigation.ts` shows when a
 * notification target cannot be opened as-is.
 *
 * Same shape as `notifications.en.ts` — a flat, typed key → string map with
 * no i18n library (see CLAUDE.md, keep the lean stack). Only `en` is selectable
 * today, so this is the sole locale. Keys live under `notifications.navigation.*`.
 */
export const realtimeNavigationEn = {
  /** Authenticated, but the notification belongs to another company (tenant stamp mismatch). */
  'notifications.navigation.otherCompany':
    'This update is for a different company. Switch to that company to open it.',
} as const;

export type RealtimeNavigationCopyKey = keyof typeof realtimeNavigationEn;

/** Look up one string by its catalogue key (a typo is a compile error). */
export function realtimeNavigationCopy(key: RealtimeNavigationCopyKey): string {
  return realtimeNavigationEn[key];
}
